module.exports = __webpack_public_path__ + "static/about-content-image-8@2x-295aa66a3ce3b110ea71cbf11cd6047b.jpg";